import { render, staticRenderFns } from "./ConfigIcon.vue?vue&type=template&id=6b540607"
import script from "./ConfigIcon.vue?vue&type=script&lang=js"
export * from "./ConfigIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports